import { useMutation, useQueryClient } from '@tanstack/react-query'

import { setExerciseGoal } from '../dal/exercise-goal-dal'
import { queryKeys } from './query-keys'

export function useSetExerciseGoal() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: setExerciseGoal,
    onMutate: async (value: number) => {
      await queryClient.cancelQueries({
        queryKey: queryKeys.exercise.goalCurrent(),
      })
      const previousGoal = queryClient.getQueryData<number | null>(
        queryKeys.exercise.goalCurrent(),
      )

      queryClient.setQueryData<number | null>(
        queryKeys.exercise.goalCurrent(),
        value,
      )

      return { previousGoal }
    },
    onError: (_error, _value, context) => {
      if (context?.previousGoal !== undefined) {
        queryClient.setQueryData(
          queryKeys.exercise.goalCurrent(),
          context.previousGoal,
        )
      }
    },
    onSuccess: async () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.exercise.goalCurrent(),
      })
      void queryClient.invalidateQueries({
        queryKey: queryKeys.activities.stats(),
      })
    },
  })
}
